<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    console.log('241129-替换下载链接及二维码')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue